module.exports = __webpack_public_path__ + "static/US2_1P_modern_v2-65945a3502f2d159636e844a9d93e73e.png";